import React, { useReducer } from 'react';
import BreadcrumbContext from './BreadcrumbContext';

const defaultBreadcrumbContext = {
  routeUrl: '',
  rpKey: '',
  isRcoreNode: false,
  breadcrumbData: []
};
const BreadcrumbContextProvider = (props) => {
  const [state, dispatch] = useReducer(breadcrumbReducer, defaultBreadcrumbContext);
  const value = { breadcrumbContext: state, dispatch };
  return <BreadcrumbContext.Provider value={value} {...props} />;
};

const breadcrumbReducer = (state, action) => {
  switch (action.type) {
    case 'POPULATE_BREADCRUMBS': {
      return {
        ...state,
        ...action.data
      };
    }
    case 'CLEAR_BREADCRUMBS': {
      return defaultBreadcrumbContext;
    }
    case 'UPDATE_BREADCRUMB': {
      // Expects a breadcrumb object with title attribute as a mandatory
      if (
        action.addBreadcrumb !== undefined &&
        action.addBreadcrumb.title !== undefined &&
        action.addBreadcrumb.title !== null &&
        action.addBreadcrumb.title !== ''
      ) {
        return {
          ...state,
          breadcrumbData: [...state.breadcrumbData, action.addBreadcrumb]
        };
      }
      throw new Error(`Title for the breadcrumb data is mandatory`);
    }
    case 'REMOVE_BREADCRUMB_ITEM': {
      // Method to remove a breadcrumb. Has to send the breadcrumb object.
      const newState = {
        ...state,
        breadcrumbData: state.breadcrumbData.filter(
          (node) =>
            node.title !== action.removeBreadcrumb.title && node.url !== action.removeBreadcrumb.url
        )
      };
      return newState;
    }
    default:
      throw new Error(`Unknown action type: ${action.type} for breadcrumb update`);
  }
};

export default BreadcrumbContextProvider;
